import React from 'react'
import styled from 'styled-components'

/**
 * Clear pre-send summary: supplier display name, venue, recipient,
 * account number, price file — plus accurate journey copy.
 */
const InviteConfirmDetails = ({
  supplierName,
  venueName,
  recipientEmail,
  accountNumber,
  priceFileName,
  journey = 'existing', // 'existing' | 'new'
  compact = false,
}) => {
  return (
    <Wrapper>
      <Rows>
        <Row>
          <Key>Inviting supplier</Key>
          <Val>{supplierName || '—'}</Val>
        </Row>
        <Row>
          <Key>Venue</Key>
          <Val>{venueName || '—'}</Val>
        </Row>
        <Row>
          <Key>Recipient email</Key>
          <Val>{recipientEmail || '—'}</Val>
        </Row>
        <Row>
          <Key>Supplier account number</Key>
          <Val>{accountNumber || '—'}</Val>
        </Row>
        <Row>
          <Key>Assigned price file</Key>
          <Val>{priceFileName || '—'}</Val>
        </Row>
      </Rows>

      {compact ? (
        <CompactNote>
          Sending creates their login and emails a temporary password. That is
          not the same as them accepting or placing an order — follow progress
          on Customers after you send.
        </CompactNote>
      ) : (
        <Journey>
          <JourneyTitle>What will happen</JourneyTitle>
          {journey === 'existing' ? (
            <ul>
              <li>
                This person already has an OMS login. They will keep using that
                same login.
              </li>
              <li>
                Access will be added for{' '}
                <strong>{venueName || 'this venue'}</strong> with your catalogue
                from{' '}
                <strong>{priceFileName || 'the selected price file'}</strong>.
              </li>
              <li>
                They will get an email from Orders Made Simple with instructions
                to open the venue and start ordering.
              </li>
              <li>
                After the email, they should sign in and open{' '}
                <strong>{venueName || 'the venue'}</strong> to place orders from
                you.
              </li>
            </ul>
          ) : (
            <ul>
              <li>
                This email is not on OMS yet. You will create their login, then
                we invite them to the venue.
              </li>
              <li>
                Access will be added for{' '}
                <strong>{venueName || 'this venue'}</strong> with your catalogue
                from{' '}
                <strong>{priceFileName || 'the selected price file'}</strong>.
              </li>
              <li>
                They will get an email with their temporary password. They sign
                in with that new login (not an existing OMS account).
              </li>
              <li>
                After the email, they should follow the link, sign in, and open{' '}
                <strong>{venueName || 'the venue'}</strong> to order from you.
              </li>
            </ul>
          )}
        </Journey>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

const Rows = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 4px 14px;
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #e2e8f0;
  font-size: 13px;

  &:last-child {
    border-bottom: none;
  }
`

const Key = styled.span`
  color: #64748b;
  flex-shrink: 0;
`

const Val = styled.span`
  color: #0f172a;
  font-weight: 600;
  text-align: right;
  word-break: break-word;
`

const Journey = styled.div`
  font-size: 13px;
  color: #475569;
  line-height: 1.45;

  ul {
    margin: 0;
    padding-left: 18px;
  }

  li {
    margin-bottom: 6px;
  }
`

const JourneyTitle = styled.strong`
  display: block;
  margin-bottom: 8px;
  color: #0f172a;
  font-size: 13px;
`

const CompactNote = styled.p`
  margin: 0;
  font-size: 13px;
  color: #475569;
  line-height: 1.45;
`

export default InviteConfirmDetails
